import React from 'react';

import { ButtonSize } from '@components/Button/variants';
import LockedLeadCaptureForm from '@components/LockedLeadCaptureForm';
import { Newsletter } from '@hooks/useCurrentNewsletter';
import {
  create_user_path,
  highlight_path,
  newsletter_post_signup_path,
  static_privacy_path,
  subscribe_promotion_path,
} from '@routes';
import { DEFAULT_ANNUAL_OFFER_CODE } from '@src/constants';

import NewsletterSignupButton from './NewsletterSignupButton';
import styles from './styles.module.scss';

interface NewsletterSignupProps {
  buttonSize?: ButtonSize;
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  gdprColorScheme: string;
  gdpr: boolean;
  isSubscribed: boolean;
  newsletter: Newsletter;
}

const NewsletterSignUp = ({
  buttonSize = 'big',
  currentUserAccessLevel,
  isLoggedIn,
  gdpr,
  gdprColorScheme,
  isSubscribed,
  newsletter,
}: NewsletterSignupProps) => {
  const canSubscribe = currentUserAccessLevel >= newsletter.accessLevel;

  return (
    <div className={styles.newsletterSignUp}>
      {isLoggedIn ? (
        <NewsletterSignupButton
          buttonSize={buttonSize}
          canSubscribe={canSubscribe}
          currentUserAccessLevel={currentUserAccessLevel}
          isSubscribed={isSubscribed}
          newsletter={newsletter}
        />
      ) : (
        <>
          {gdpr && (
            <div className={`marketing-opt-in-container ${gdprColorScheme} `}>
              <label className="marketing-opt-in">
                <span className="form-control-text">
                  Get breaking news, relevant articles, and special event &amp; editorial invites
                </span>
                <input type="checkbox" value="1" name="user[opt_in]" className="opt-in" required />
                <span className="checkbox-fill"></span>
              </label>
            </div>
          )}
          <LockedLeadCaptureForm
            buttonText="Sign up"
            colorScheme="light"
            endpointUri={
              canSubscribe
                ? create_user_path({ newsletter_ids: [newsletter.id] })
                : create_user_path()
            }
            formLocation="newsletter_signup"
            leadType={`${newsletter.name.replace(' ', '_').toLowerCase()}_newsletter_lead_type`}
            redirectUri={
              canSubscribe
                ? newsletter_post_signup_path({
                    id: newsletter.id,
                  })
                : subscribe_promotion_path({
                    offer: newsletter.offer?.code || DEFAULT_ANNUAL_OFFER_CODE,
                    redirect_to: highlight_path(newsletter.slug),
                  })
            }
            trackingProps={{
              name: 'newsletter_subscribe',
              'lead-details': JSON.stringify({ newsletter_name: newsletter.name }),
            }}
          />
          <div className={styles.privacy}>
            By providing your email, you agree to The Information&rsquo;s{' '}
            <a href={static_privacy_path()}>Privacy Policy</a>
          </div>
        </>
      )}
    </div>
  );
};

export default NewsletterSignUp;
